exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".productDetail[data-v-2ddb8b5e]{padding:16px;background:#eef5e5}.productDetail__info[data-v-2ddb8b5e]{border-bottom:1px solid #d8d8d8;padding-bottom:8px}.productDetail__price[data-v-2ddb8b5e]{height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:12px}.productDetail__price .price[data-v-2ddb8b5e]{font-size:16px;font-weight:700;color:#8cc63f}.productDetail .cornerName[data-v-2ddb8b5e]{font-size:12px;margin:0 0 4px;color:#e4007f}.productDetail .productName[data-v-2ddb8b5e]{font-size:16px;margin:0 0 4px;font-weight:700;color:#141414}.productDetail .counselorName[data-v-2ddb8b5e]{font-size:12px;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ddb8b5e","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/EntryForm/EntryFormHeaderNoSteps.vue
// module id = F7Z5
// module chunks = 0